<template>
  <DatePicker type="daterange"    :options="options" v-model="date"  :isIncludeToday="isIncludeToday"  :placeholder="$t('page.common.choose')+$t('page.chart.timeframe')" :editable="editable" :clearable="true" class="resetable"></DatePicker>
</template>

<script>
/**
 * DatePicker中的ab便捷用法
 * <ab-date-range :start.sync="startTime" :end.sync="endTime"></ab-date-range>
 */
 import Vue from 'vue'
export default {
 	name: 'abDataRange',
	props: {
		start : {
			required: true
		},
		end : {
			required: true
		},
		editable : {
			default : false
		},
    isIncludeToday : {
      default : true
    },
		placeholder : {
			default : "请选择时间范围"
		}
	},
  	data :function () {
	    return {
        options: {
          shortcuts: [
            {
              text: $t('page.chart.week'),
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                return [start, end];
              }
            },
            {
              text: $t('page.chart.month'),
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                return [start, end];
              }
            },
            {
              text: $t('page.chart.threeMonths'),
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                return [start, end];
              }
            }
          ]
        },
	    	date:[],
	    }
	},
	created : function(){
 		this.startChange();
 		this.endChange();
 	},
 	mounted : function(){
 	},
	methods: {
		startChange : function(){
    		if(!this.start){
 				this.date = [];
 				return;
 			}else{
 				this.date[0] = this.start.toDate("yyyy-MM-dd");
 			}
    	},
    	endChange : function(){
    		if(!this.end){
 				this.date = [];
 				return;
 			}else{
 				this.date[1] = this.end.toDate("yyyy-MM-dd");
 			}
    	}
  	},
 	watch : {
 		date : function(){
 			if(!this.date[0]){
 				this.$emit('update:start',null);
 				this.$emit('update:end',null);
 			}else{
        if (this.isIncludeToday === false) {
          this.$emit('update:start', this.date[0].format("yyyy-MM-dd"));
          this.$emit('update:end', this.date[1].format("yyyy-MM-dd"));
        } else {
          this.$emit('update:start', this.date[0].format("yyyy-MM-dd"));
          this.$emit('update:end', this.date[1].format("yyyy-MM-dd") + " 23:59:59");
        }
      }
 		},
 		start : function(newVal,oldVal){
 			this.startChange();
 		},
 		end : function(newVal,oldVal){
 			this.endChange();
 		}
 	}
}
</script>
